const CHARACTERS = [
	['&', '&amp'],
	['<', '&lt'],
	['>', '&gt'],
	['"', '&quot'],
	["'", '&#x27'],
	['/', '&#x2F']
];

/**
 * HTML encoder.
 */
export default class HtmlEncoder {
	/**
	 * Encode for attribute.
	 *
	 * @param text Model object.
	 * @returns Encoded text.
	 */
	public static encodeForAttribute(text: string): string {
		for (const character of CHARACTERS) {
			text = text.replace(new RegExp(character[0], 'gm'), character[1] + ';');
		}
		return text;
	}
}
